module.exports = __webpack_public_path__ + "static/media/RESUME_RML.3dce2abf.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/RESUME_RML.pdf
// module id = 302
// module chunks = 0